module.exports = __webpack_public_path__ + "media/logo_anime.c5994165.mp4";